import { useCallback } from "react";

export function scrollToSection(hash) {
  const el = document.querySelector(hash);
  if (!el) return;
  if (window.lenis) {
    window.lenis.scrollTo(el, { offset: -76, duration: 1.2 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
}

export function openWhatsApp(number, message) {
  const url = `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank", "noopener,noreferrer");
}

export function useScrollToSection() {
  return useCallback((e, hash) => {
    if (e) e.preventDefault();
    scrollToSection(hash);
  }, []);
}
